import React, { useContext } from "react";
import AssessmentContext from "module/assessment/context/AssessmentContext";
import { AssessmentInterface } from "module/assessment/types";
import useDateFormat from "toolkit/useDateFormat";
import AssessmentCompletionEndDateTimeLabelField from "module/assessment/enrichedComponent/completionEndDateTimeField/AssessmentCompletionEndDateTimeLabelField";

const AssessmentCompletionEndDateTimeFieldContainer: React.FC = () => {
  const { entity } = useContext(AssessmentContext);
  const { formatDateTime } = useDateFormat();

  const { completionEndDate } = entity as AssessmentInterface;

  return (
    <AssessmentCompletionEndDateTimeLabelField
      {...{ completionEndDate, formatDateTime }}
    />
  );
};

export default React.memo(AssessmentCompletionEndDateTimeFieldContainer);
